import { useSuspenseQuery } from '@tanstack/react-query';

import { contractQueryOptions } from '../data-provider';

export const useSuspenseContract = (contractKey: string) => useSuspenseQuery(contractQueryOptions(contractKey));
